module.exports = __webpack_public_path__ + "static/media/hall-AH.74e94dce.svg";